// extracted by mini-css-extract-plugin
export default {"red":"custom-chip_red__x1oIp","tooltip":"custom-chip_tooltip__UJYXE"};